import React, { useEffect, useState } from "react";
import { cn } from "@sys42/utils";
// import { } from '../../system42'
import * as styles from "./styles.module.css";
import { cookieDomain, cookies } from "../../helpers";
import { useIsInDayRange } from "../../hooks/useIsInDayRange";

export function closeBanner(bannerId) {
  const exdays = 60;
  const cvalue = "closed";
  const expires = new Date();
  expires.setTime(expires.getTime() + exdays * 24 * 60 * 60 * 1000);
  cookies.set("ub_banner_" + bannerId, cvalue, {
    path: "/",
    domain: cookieDomain,
    expires,
  });
}

export function Banner(props) {
  const { className, children, bannerId, dayStart, dayEnd, ...containerProps } =
    props;

  const [active, setActive] = useState(false);
  const showTemporaryBanner = useIsInDayRange(dayStart, dayEnd);

  useEffect(() => {
    if (cookies.get("ub_banner_" + bannerId) !== "closed") {
      if ((dayStart || dayEnd) && !showTemporaryBanner) {
        // If day is set but it is not this day
        setActive(false);
      } else {
        setActive(true);
      }
    } else {
      setActive(false);
    }
  }, [bannerId, showTemporaryBanner, dayStart, dayEnd]);

  function handleClickClose() {
    closeBanner(bannerId);
    setActive(false);
  }

  if (active) {
    return (
      <div className={cn(className, styles.banner)} {...containerProps}>
        {children}
        <button className={styles.close} onClick={handleClickClose}>
          close
        </button>
      </div>
    );
  }

  return false;
}
